;(function () {
  'use strict'

  /**
   * Trigger a file download programmatically using a hidden anchor with the
   * `download` attribute. This avoids firing `beforeunload` on the current
   * page (which would strip the header's scroll listener and leave it stuck).
   */
  function triggerDownload(href) {
    const anchor = document.createElement('a')
    anchor.href = href
    anchor.setAttribute('download', '')
    anchor.style.display = 'none'
    document.body.appendChild(anchor)
    anchor.click()
    anchor.remove()
  }

  /**
   * Attach a download click handler to an element. The handler resolves the
   * enclosing anchor, optionally triggers a programmatic download and pushes a
   * `download file` event to the Adobe Data Layer.
   */
  function attachDownloadHandler(element, reference) {
    element.addEventListener('click', function (event) {
      const href = this.closest('a')?.getAttribute('href') ?? ''
      const dataDownloadItem = this.closest('a')?.getAttribute('data-download-item')

      // Only trigger custom download if data-download-item is not present (null/undefined), not if it's empty string
      if (href && dataDownloadItem == null) {
        event.preventDefault()
        triggerDownload(href)
      }

      window.adobeDataLayer?.push({
        event: 'download file',
        eventInfo: {
          reference,
          fileName: href.split('/').pop(),
        },
      })
    })
  }

  /**
   * Determine whether a download list item exposes multiple language variants.
   * Those items carry the real download links in the language list, so their
   * wrapper anchor is only a placeholder and must not be tracked directly.
   */
  function hasLanguageVariants(element) {
    const item = element.closest('.cmp-download-list__item, .cmp-download-list__item--with-languages')
    return (
      item?.classList.contains('cmp-download-list__item--with-languages') ||
      item?.querySelector('.cmp-download-list__action-language-link') != null
    )
  }

  function onDocumentReady() {
    // The whole download row is a clickable anchor. The visible action label is
    // an (often empty) span that ignores pointer events, so the actual click
    // always lands on this wrapper anchor.
    const downloadWrappers = document.querySelectorAll('.cmp-download-list__action-wrapper')
    // Some components (e.g. product information) render the action label itself
    // as the download anchor without a wrapper.
    const downloadActionLabels = document.querySelectorAll('a.cmp-download-list__action-label')
    const downloadLanguagesListItems = document.querySelectorAll('.cmp-download-list__action-language-link')

    for (const downloadWrapper of downloadWrappers) {
      // Skip language variant items: their downloads are tracked via the
      // dedicated language links below to avoid duplicate/placeholder events.
      if (hasLanguageVariants(downloadWrapper)) {
        continue
      }

      attachDownloadHandler(downloadWrapper, 'download list item')
    }

    for (const downloadActionLabel of downloadActionLabels) {
      // Labels wrapped by an action wrapper are already covered above.
      if (downloadActionLabel.closest('.cmp-download-list__action-wrapper')) {
        continue
      }

      attachDownloadHandler(downloadActionLabel, 'download list item')
    }

    for (const downloadLLanguagesListItem of downloadLanguagesListItems) {
      attachDownloadHandler(downloadLLanguagesListItem, 'download languages list item')
    }
  }

  if (document.readyState !== 'loading') {
    onDocumentReady()
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady)
  }
})()
